import { registerPlugin } from '@capacitor/core';

export interface MetaAdsPlugin {
    logEvent(options: { eventName: string; params?: Record<string, string>; valueToSum?: number }): Promise<void>;
    setExternalId(options: { externalId: string }): Promise<void>;
}

const MetaAds = registerPlugin<MetaAdsPlugin>('MetaAds');

export default MetaAds;
